/**
 * @generated SignedSource<<16240faa10d2c21992bdcab8946e512f>>
 * @relayHash ee392579fe941e25924922cbe6e74b19
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b2b412853cb2e067403107800e6bf6a94c8346b563ac95be61ffb329b6395f3f

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { src_jiraBusinessApprovalsSettingsQuery } from './src_jiraBusinessApprovalsSettingsQuery.graphql';

const node: PreloadableConcreteRequest<src_jiraBusinessApprovalsSettingsQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "b2b412853cb2e067403107800e6bf6a94c8346b563ac95be61ffb329b6395f3f",
    "metadata": {},
    "name": "src_jiraBusinessApprovalsSettingsQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
